$(document).ready(function() {
	$("table").each(function () {
		$(this).addClass("sortable");
		const header = $(this).find("th:first-child");
		header.click();
		header.click();
	});

	$(".emoji").each(function () {
		const sortString = $(this).attr("alt");
		$(this).parent().attr("data-sort", sortString);
	});

	$("td[style*='text-align: left']").each(function () {
		const sortString = $(this).text().split(".");
		const date = new Date(sortString[2], sortString[1] - 1, sortString[0]);
		const timestamp = date.getTime();
		$(this).attr("data-sort", timestamp);
	});
});
